// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-card {
  background: #161616;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.video-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.video-thumbnail {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.video-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.video-card:hover .video-thumbnail img {
  transform: scale(1.05);
}

.duration-badge {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0,0,0,0.8);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.video-card:hover .play-overlay {
  opacity: 1;
}



.video-info {
  padding: 1.5rem;
  background: #161616;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.video-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.video-summary {
  flex: 1 1;
}

.video-summary p {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}


.status-indicators {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.status-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.status-badge.transcript {
  background: #e3f2fd;
  color: #1976d2;
}

.status-badge.summary {
  background: #f3e5f5;
  color: #7b1fa2;
}

/* Responsive Design */
@media (max-width: 768px) {
  .video-thumbnail {
    height: 160px;
  }
  
  .video-info {
    padding: 1rem;
  }
  
  .video-title {
    font-size: 1rem;
  }
  
  .video-summary p {
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .video-thumbnail {
    height: 140px;
  }
  
  .video-info {
    padding: 0.75rem;
    gap: 0.75rem;
  }
  
  .status-indicators {
    gap: 0.25rem;
  }
  
  .status-badge {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/VideoCard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;;;AAIA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF","sourcesContent":[".video-card {\n  background: #161616;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.video-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0,0,0,0.15);\n}\n\n.video-thumbnail {\n  position: relative;\n  width: 100%;\n  height: 180px;\n  overflow: hidden;\n}\n\n.video-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.video-card:hover .video-thumbnail img {\n  transform: scale(1.05);\n}\n\n.duration-badge {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background: rgba(0,0,0,0.8);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.play-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.video-card:hover .play-overlay {\n  opacity: 1;\n}\n\n\n\n.video-info {\n  padding: 1.5rem;\n  background: #161616;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.video-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: white;\n  margin: 0;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.video-summary {\n  flex: 1;\n}\n\n.video-summary p {\n  color: #666;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n\n.status-indicators {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.status-badge {\n  font-size: 0.75rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.status-badge.transcript {\n  background: #e3f2fd;\n  color: #1976d2;\n}\n\n.status-badge.summary {\n  background: #f3e5f5;\n  color: #7b1fa2;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .video-thumbnail {\n    height: 160px;\n  }\n  \n  .video-info {\n    padding: 1rem;\n  }\n  \n  .video-title {\n    font-size: 1rem;\n  }\n  \n  .video-summary p {\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .video-thumbnail {\n    height: 140px;\n  }\n  \n  .video-info {\n    padding: 0.75rem;\n    gap: 0.75rem;\n  }\n  \n  .status-indicators {\n    gap: 0.25rem;\n  }\n  \n  .status-badge {\n    font-size: 0.7rem;\n    padding: 0.2rem 0.4rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
